<template>
     <div>
        <div v-for="(item,index) in list" :key="index">
            <a-tag color="cyan" style="margin-bottom:4px;">
            {{configName[index] ? configName[index] : index  + '：'}}   {{item}}
            </a-tag>
            <br>
        </div>
     </div>
</template>

<script>
const configName = {
    'hystrix.threadpool.%s.coreSize':'核心线程数',
    'hystrix.command.%s.circuitBreaker.requestVolumeThreshold':'跳闸最小请求数量',
    'hystrix.command.%s.circuitBreaker.errorThresholdPercentage':'错误半分比阀值',
    'hystrix.command.%s.circuitBreaker.sleepWindowInMilliseconds':'跳闸休眠时间（ms）',
    'hystrix.command.%s.execution.isolation.thread.timeoutInMilliseconds':'超时时间上限（ms）',
};
export default {
    data() {
        return {
            configName,
            list:JSON.parse(this.authedStr)
        }
    },
    props:{
        authedStr:String
    },
};
</script>

<style lang="less" scoped>
</style> 